module.exports = __webpack_public_path__ + "static/media/208.c7e47760.png";